/**
 * 假设列表数据中，keyName相同的条目应该被行合并显示，
 * 则此函数返回一个数组，数组的每一项的index是需要应用行合并的行号，
 * 每一项是一个长度为2的数组，数组的第一项是行合并值，第二项是列合并值，该对象可直接被el-table的spanMethod方法使用，
 * 使用方法见下面的arraySpanMethod函数
 */
export function getRowSpanReg(keyName, list) {
    if (!keyName || typeof keyName !== 'string' || !list || typeof list !== 'object' || !Array.isArray(list) || !list.length || !list[0][keyName]) {
        return [];
    }
    let rowSpanBeginIdx = null,
        lastKey = null,
        thisKey = null,
        rowSpanBegin = false,
        rowSpanReg = [];

    list.forEach((item, idx) => {
        thisKey = item[keyName];
        if (thisKey && thisKey === lastKey) {
            rowSpanReg[idx] = [0, 0];
            if (!rowSpanBegin) {
                rowSpanBegin = true;
                rowSpanBeginIdx = idx - 1;
                rowSpanReg[rowSpanBeginIdx] = [];
                rowSpanReg[rowSpanBeginIdx][0] = 2;
                rowSpanReg[rowSpanBeginIdx][1] = 1;
            } else {
                rowSpanReg[rowSpanBeginIdx][0]++;
            }
        } else {
            rowSpanBegin = false;
            rowSpanBeginIdx = null;
        }
        lastKey = thisKey;
    });
    return rowSpanReg;
}

/** 说明
 * 该函数只用做行合并
 * 输入参数colFilter的作用是筛选出需要做行合并的列号
 * 然后根据上面的getRowSpanReg计算得到的rowSpanReg，去返回el-table需要的行合并参数
 */
export function arraySpanMethod(rowSpanReg, columns, { row, column, rowIndex, columnIndex }) {
    if (columns[columnIndex] && columns[columnIndex].allowSpanRow) {
        if (rowSpanReg[rowIndex]) {
            return {
                rowspan: rowSpanReg[rowIndex][0],
                colspan: rowSpanReg[rowIndex][1]
            };
        }
    }
    return { rowspan: 1, colspan: 1 };
}

/** 说明
 * 该函数将list中每一条记录按其中的splitKeyName（认为是数组）展开成多项并返回
 */
export function tableDataSplitor(list, splitKey) {
    if (!list || !splitKey || !Array.isArray(list) || !list.length || (typeof splitKey !== 'string' && !(splitKey instanceof Function))) {
        return [];
    }
    let outList = [];
    list.forEach(item => {
        let tmpList = [];
        if (typeof splitKey === 'string') {
            let commonPart = null;
            let splitArr = item[splitKey];
            if (Array.isArray(splitArr) && splitArr.length) {
                if (!commonPart) {
                    commonPart = { ...item };
                    delete commonPart[splitKey];
                }
                splitArr.forEach(skuItem => {
                    tmpList.push({
                        ...commonPart,
                        ...skuItem
                    });
                });
                outList.push(...tmpList);
            } else {
                outList.push(item);
            }
        } else if (splitKey instanceof Function) {
            tmpList = splitKey(item);
            if (tmpList && Array.isArray(tmpList)) {
                outList.push(...tmpList);
            }
        }
    });
    return outList;
}
